import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { EndpointsService } from './endpoints.service';
import { AlertService } from '../base/alert.service';
import { OrderSaveSource } from 'src/app/interfaces/order-save-source';
@Injectable({
  providedIn: 'root',
})
export class DataServerService {
  constructor(
    private api: ApiService,
    private endpoints: EndpointsService,
    private alert: AlertService
  ) {}

  async requestWrapper<T>(request: () => Promise<T>) {
    try {
      const response = await request();
      //console.log(response);
      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }


  async getProductChanges(params?: { limit?: number; page?: number; action?: string; sku?: string; since?: string }) {
    return this.requestWrapper(() =>
      this.api.getRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorProductChanges,
        {
          ...(params?.limit ? { limit: String(params.limit) } : { limit: '50' }),
          ...(params?.page ? { page: String(params.page) } : {}),
          ...(params?.action ? { action: params.action } : {}),
          ...(params?.sku ? { sku: params.sku } : {}),
          ...(params?.since ? { since: params.since } : {}),
        }
      )
    );
  }

  async getProducts() {
    return this.requestWrapper(() =>
      this.api.getRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorProducts,
        { limit: '10000' }
      )
    );
  }

  // Payload CMS - Defaults
  async getDefaults() {
    return this.requestWrapper(() =>
      this.api.getRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorDefaults,
        { limit: '1' }
      )
    );
  }

  async updateDefaults(id: string, body: any) {
    return this.requestWrapper(() =>
      this.api.patchRequest<any>(
        this.endpoints.kontorUrl,
        `${this.endpoints.kontorDefaults}/${id}`,
        body
      )
    );
  }

  async updateProductPrice(id: string, price: number) {
    return this.requestWrapper(() =>
      this.api.patchRequest<any>(
        this.endpoints.kontorUrl,
        `${this.endpoints.kontorProducts}/${id}`,
        { price }
      )
    );
  }

  async getLexwareStatus() {
    return this.requestWrapper(() =>
      this.api.getRequest<any>(
        this.endpoints.flowUrl,
        this.endpoints.lexwarestatus
      )
    );
  }


  // PDF Endpoints

  async generateConfirm(body: any) {
    return this.requestWrapper(() =>
      this.api.postRequest<any>(
        this.endpoints.flowUrl,
        this.endpoints.generateConfirm,
        body
      )
    );
  }

  async generateWhole(body: any) {
    return this.requestWrapper(() =>
      this.api.postRequest<any>(
        this.endpoints.flowUrl,
        this.endpoints.generateWhole,
        body
      )
    );
  }




  async getLexwareContacts() {
    return this.requestWrapper(() =>
      this.api.getRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorContacts,
        { limit: '10000' }
      )
    );
  }

  async getGoogleContacts() {
    return this.getLexwareContacts();
  }

  async postLexwareContact(body: any) {
    return this.requestWrapper(() =>
      this.api.postRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorContacts,
        body
      )
    );
  }

  async patchLexwareContact(id: number, body: any) {
    return this.requestWrapper(() =>
      this.api.patchRequest<any>(
        this.endpoints.kontorUrl,
        `${this.endpoints.kontorContacts}/${id}`,
        body
      )
    );
  }

  async postLexwareDelivery(body: any) {

    return this.requestWrapper(() =>
      this.api.postRequest<any>(
        this.endpoints.flowUrl,
        this.endpoints.lexCreateDeliveryNote,
        body
      )
    );

  }

  async postLexwareInvoice(body: any) {

    return this.requestWrapper(() =>
      this.api.postRequest<any>(
        this.endpoints.flowUrl,
        this.endpoints.lexCreateInvoice,
        body
      )
    );

  }

  async setLexwareStatus(orderId: string, status: 'pending' | 'done' | 'failed') {
    return this.requestWrapper(() =>
      this.api.patchRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorLexwareStatus,
        { orderId, status }
      )
    );
  }

  async triggerLexwareTransfer(sourceType: 'order' | 'delivery', sourceId: string) {
    return this.requestWrapper(() =>
      this.api.postRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorLexwareTransferTrigger,
        { sourceType, sourceId }
      )
    );
  }

  async getLexwareQueueItem(id: string) {
    return this.requestWrapper(() =>
      this.api.getRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorLexwareQueue,
        { id }
      )
    );
  }

  async getLexwareTransferHistoryForSource(sourceId: string) {
    return this.requestWrapper(() =>
      this.api.getRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorLexwareQueue,
        { sourceId }
      )
    );
  }

  async confirmLexwareEntry(id: string, confirmed: boolean) {
    return this.requestWrapper(() =>
      this.api.patchRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorLexwareQueueConfirm,
        { id, confirmed }
      )
    );
  }

  async closeOrderInvoicing(orderId: string, closed: boolean) {
    return this.requestWrapper(() =>
      this.api.patchRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorOrdersCloseInvoicing,
        { orderId, closed }
      )
    );
  }

  async changeOrderOwner(orderId: string, newOwnerId: string) {
    return this.requestWrapper(() =>
      this.api.patchRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorOrdersChangeOwner,
        { orderId, newOwnerId }
      )
    );
  }

  async getLexwareQueueHistory(limit: number = 10) {
    return this.requestWrapper(() =>
      this.api.getRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorLexwareQueue,
        { history: 'true', limit }
      )
    );
  }

  async getLexwareQueuePendingCount() {
    return this.requestWrapper(() =>
      this.api.getRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorLexwareQueuePendingCount,
        {}
      )
    );
  }

  async getLexwareSettings() {
    return this.requestWrapper(() =>
      this.api.getRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorLexwareSettings,
        {}
      )
    );
  }

  async updateLexwareSettings(data: { transferMode?: 'server' | 'manual'; runnerTimeoutMinutes?: number }) {
    return this.requestWrapper(() =>
      this.api.patchRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorLexwareSettings,
        data
      )
    );
  }

  async logInvoice(orderId: string) {
    return this.requestWrapper(() =>
      this.api.postRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorLogInvoice,
        { orderId }
      )
    );
  }

  async getInvoices(limit: number = 20) {
    return this.requestWrapper(() =>
      this.api.getRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorInvoices,
        {
          limit: String(limit),
          sort: '-createdAt',
        }
      )
    );
  }

  async getAllInvoices() {
    return this.requestWrapper(() =>
      this.api.getRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorInvoices,
        {
          limit: '10000',
          sort: '-createdAt',
        }
      )
    );
  }

  async resetContacts() {
    return this.requestWrapper(() =>
      this.api.getRequest<any>(
        this.endpoints.flowUrl,
        this.endpoints.resetContacts
      )
    );
  }

  async getOrders() {
    return this.requestWrapper(() =>
      this.api.getRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorOrders,
        { limit: '10000', depth: '1' }
      )
    );
  }

  async getOrderById(orderId: any) {
    return this.requestWrapper(() =>
      this.api.getRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorOrders,
        { where: '(orderId,eq,' + orderId + ')' }
      )
    );
  }

  // Validiere und bereinige Email
  private validateAndCleanEmail(order: any): any {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Erstelle eine Kopie um das Original nicht zu verändern
    const cleanedOrder = { ...order };

    // Prüfe ob customerEmail existiert und gültig ist
    if (cleanedOrder.customerEmail) {
      if (!emailRegex.test(cleanedOrder.customerEmail)) {
        // Ungültige Email - entfernen
        console.warn('Ungültige customerEmail entfernt:', cleanedOrder.customerEmail);
        delete cleanedOrder.customerEmail;
      }
    }

    return cleanedOrder;
  }

  async updateOrder(order: any) {
    const cleanedOrder = this.validateAndCleanEmail(order);
    return this.requestWrapper(() =>
      this.api.patchRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorOrders,
        cleanedOrder
      )
    );
  }

  /**
   * @param saveSource Welche Aktion diesen Save ausgelöst hat. Wird serverseitig nur
   *   protokolliert (nicht gespeichert) und dient der Ursachenklärung, wenn ein Save
   *   ein gefülltes Feld leeren will — siehe guardOrderFields im Backend.
   */
  async upsertOrder(order: any, saveSource: OrderSaveSource = 'unbekannt') {
    const { karmaNoteRef: _removed, ...orderWithoutKarmaRef } = order;
    const cleanedOrder = this.validateAndCleanEmail(orderWithoutKarmaRef);
    return this.requestWrapper(() =>
      this.api.postRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorOrdersUpsert,
        { ...cleanedOrder, saveSource }
      )
    );
  }

  async createOrder(order: any) {
    const cleanedOrder = this.validateAndCleanEmail(order);
    return this.requestWrapper(() =>
      this.api.postRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorOrders,
        cleanedOrder
      )
    );
  }

  async loginUser(email: string, password: string) {
    return this.requestWrapper(() =>
      this.api.postRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorLogin,
        {
          email: email,
          password: password
        }
      )
    );
  }

  // Deliveries

  async createDelivery(orderId: string, products: any[]) {
    return this.requestWrapper(() =>
      this.api.postRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorCreateDelivery,
        { orderId, products }
      )
    );
  }

  async getRemainingQuantities(orderId: string) {
    return this.requestWrapper(() =>
      this.api.postRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorRemainingQuantities,
        { orderId }
      )
    );
  }

  async logDeliveryInvoice(deliveryId: string) {
    return this.requestWrapper(() =>
      this.api.postRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorLogDeliveryInvoice,
        { deliveryId }
      )
    );
  }

  async getDeliveriesForOrder(orderId: string) {
    return this.requestWrapper(() =>
      this.api.getRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorDeliveries,
        {
          'where[orderId][equals]': orderId,
          sort: '-createdAt',
          limit: '1000',
        }
      )
    );
  }

  async updateDelivery(deliveryId: string, products: any[]) {
    return this.requestWrapper(() =>
      this.api.patchRequest<any>(
        this.endpoints.kontorUrl,
        `${this.endpoints.kontorDeliveries}/${deliveryId}`,
        { products }
      )
    );
  }

  // Versions

  async getOrderVersions(orderId: string) {
    // First get the order to find its internal ID
    const orderResult = await this.requestWrapper(() =>
      this.api.getRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorOrders,
        { 'where[orderId][equals]': orderId, limit: '1' }
      )
    );

    if (orderResult?.data?.docs?.[0]?.id) {
      const orderDocId = orderResult.data.docs[0].id;
      // Use built-in Payload versions endpoint
      return this.requestWrapper(() =>
        this.api.getRequest<any>(
          this.endpoints.kontorUrl,
          this.endpoints.kontorOrderVersions,
          { 
            'where[parent][equals]': orderDocId,
            sort: '-updatedAt',
            limit: '100',
            depth: '2' // Populate user relationships
          }
        )
      );
    }

    return { status: 404, data: { error: 'Order not found' } };
  }

  // Users

  async getUsers() {
    return this.requestWrapper(() =>
      this.api.getRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorUsers,
        { limit: '1000' }
      )
    );
  }

  // Comments

  async addOrderComment(orderId: string, text: string, isChangeReason: boolean = false) {
    return this.requestWrapper(() =>
      this.api.postRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorAddOrderComment,
        { orderId, text, isChangeReason }
      )
    );
  }

  // Karma B2B

  async fetchAndImportKarma(karmaUser: string, karmaPass: string) {
    return this.requestWrapper(() =>
      this.api.postRequest<{ success: boolean; fetched: number; created: number; updated: number; errors: number; errorDetails?: string[] }>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorFetchAndImportKarma,
        { karmaUser, karmaPass }
      )
    );
  }

  async getKarmaUnavailableProducts(limit: number = 500) {
    return this.requestWrapper(() =>
      this.api.getRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorKarmaUnavailableProducts,
        { limit }
      )
    );
  }

  async submitFeedback(data: { type: 'bug' | 'feature' | 'info'; title: string; message: string; contactEmail?: string; appVersion?: string }) {
    return this.requestWrapper(() =>
      this.api.postRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorFeedback,
        data
      )
    );
  }

  async getKarmaCartLog(limit: number = 10) {
    return this.requestWrapper(() =>
      this.api.getRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorKarmaCartLog,
        { limit }
      )
    );
  }

  async getKarmaCartLogForOrder(orderId: string, limit: number = 10) {
    return this.requestWrapper(() =>
      this.api.getRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorKarmaCartLog,
        {
          limit,
          sort: '-createdAt',
          'where[orderId][equals]': orderId,
        }
      )
    );
  }

  async getImportStatus() {
    return this.requestWrapper(() =>
      this.api.getRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorImportStatus,
        {}
      )
    );
  }

  async updateImportStatus(data: { karmaAutoImportEnabled?: boolean }) {
    return this.requestWrapper(() =>
      this.api.patchRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorImportStatus,
        data
      )
    );
  }

  async sendToKarma(orderId: string, kuerzelMode: 'user' | 'customer', opts: {
    paymentId: string;
    deliveryDate: string;
    email: string;
    phone: string;
    note?: string;
  }) {
    return this.requestWrapper(() =>
      this.api.postRequest<any>(
        this.endpoints.kontorUrl,
        this.endpoints.kontorCreateKarmaCart,
        { orderId, kuerzelMode, ...opts }
      )
    );
  }

}


